import { render, staticRenderFns } from "./LogTable.vue?vue&type=template&id=01f38b2a&scoped=true&"
import script from "./LogTable.vue?vue&type=script&lang=js&"
export * from "./LogTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f38b2a",
  null
  
)

export default component.exports